export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail eller brugernavn',
      invalidEmailOrUsername: 'Ugyldig e-mail eller brugernavn',
      invalidPassword: 'Ugyldig adgangskode',
      logInToPlanka: 'Log på Planka',
      noInternetConnection: 'Ingen forbindelse til internettet',
      pageNotFound_title: 'Side ikke fundet',
      password: 'Adgangskode',
      projectManagement: 'Projektstyring',
      serverConnectionFailed: 'Ingen forbindelse til serveren',
      unknownError: 'Ukendt fejl - prøv igen',
    },

    action: {
      logIn: 'Log på',
    },
  },
};
